import './Content.css';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import { Preferences } from '@capacitor/preferences';
import { useSnackbar } from 'notistack';
import { Button } from '@mui/material';
import axios from 'axios';
// Functions
import { onUpdateFilterData } from '../../exportFunctions/standardExportFunctions';
// Components
import StandardPreviewCard from '../../components/StandardPreviewCard/StandardPreviewCard';
import IonicPageWrapper from '../../components/IonicPageWrapper/IonicPageWrapper';
import StandardButton from '../../components/StandardButton/StandardButton';

function Content() {
  const history = useHistory()
  const { pathname } = useLocation();
  const { enqueueSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(true)
  const [cardData, setCardData] = useState([])
  const [mappedCardData, setMappedCardData] = useState(null) // null means not loaded yet, [] means loaded but empty

  const [cardPushState, setCardPushState] = useState({});

  useEffect(() => {
    if (pathname == '/home') {

      fetchIDcardByClassID()
      fetchMappedData()
    }
  }, [pathname])

  useEffect(() => {
    // Only call onUpdateBtnStatus when both cardData is loaded and mappedCardData has been fetched (null means not fetched yet)
    if (Object.keys(cardData)?.length > 0 && mappedCardData !== null && !loading) {
      onUpdateBtnStatus();
    }
  }, [mappedCardData, cardData, loading])

  useEffect(() => {
    if (Object.keys(cardPushState).length === 0) return;
    if (!cardData || Object.keys(cardData).length === 0) return;

    // if (cardPushState?.verified === 1) return;

    if (cardPushState?.cardUpdate) {
      // Ensure cData has all required fields
      const cDataWithId = { 
        ...cardPushState?.cData, 
        id: cardPushState?.cData?.id || cardPushState?.cData?.icard_id 
      };
      history.replace("/update", { 
        ...cardPushState, 
        cData: cDataWithId 
      });
    } else {
      history.replace("/update", { 
        cData: cardData, 
        cardUpdate: false 
      });
    }

  }, [cardPushState, cardData])

  const onUpdate = () => {
    if (cardPushState?.verified === 1) return;

    if (cardPushState?.cardUpdate) {
      history.push("/update", { ...cardPushState, cData: { ...cardPushState?.cData, id: cardPushState?.cData?.id || cardPushState?.cData?.icard_id } })
    } else {
      history.push("/update", { cData: cardData, cardUpdate: false })
    }
  }

  const fetchIDcardByClassID = async () => {
    const { value } = await Preferences.get({ key: 'gjaii_IDCARD_user' });
    if (value == 'undefined' || !JSON.parse(value)?.schoolid) return enqueueSnackbar('Please Try Again !!!', { variant: 'error' });

    await axios.post(`${process.env.REACT_APP_BASE_URL}/user/getidcardbyclassidandschoolid`, { school_id: JSON.parse(value)?.schoolid, class_id: JSON.parse(value)?.classid }) // Send school ID
    // await axios.post(`${process.env.REACT_APP_BASE_URL}/user/getidcardbyclassid`, { class_id: JSON.parse(value)?.schoolid })
      .then(res => {
        if (res.data.success) {
          setCardData(res?.data?.data?.[0])
        } else {
          enqueueSnackbar(res.data.message, { variant: 'error' });
        }
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
        enqueueSnackbar('Error, Please Try Again !!!', { variant: 'error' });
      })
  }

  const fetchMappedData = async () => {
    const { value } = await Preferences.get({ key: 'gjaii_IDCARD_user' });
    if (value == 'undefined' || !JSON.parse(value)?.id) return enqueueSnackbar('Please Try Again !!!', { variant: 'error' });
    console.log("getmapped_data_byuserid api is called from Content page", JSON.parse(value)?.id)
    await axios.post(`${process.env.REACT_APP_BASE_URL}/user/getmapped_data_byuserid`, { user_id: JSON.parse(value)?.id })
      .then(async res => {
        if (res.data.success) {
          setMappedCardData(res.data.data)
        } else {
          setMappedCardData([]);
          await Preferences.set({ key: 'is_downloaded', value: 0 })
        }
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar('Error, Please Try Again !!!', { variant: 'error' });
      })
  }

  const onUpdateBtnStatus = async () => { // value is the data comin from fetchMappedData()
    if (!cardData || Object.keys(cardData).length === 0) return;
    
    if (mappedCardData === null || mappedCardData?.length === 0) {
      // For Making New ID Card 
      setCardPushState({ cardUpdate: false, verified: false });
      return;
    }

    const cardIndex = mappedCardData?.findIndex(data => data.id_card?.icard_id === cardData?.id);
    await Preferences.set({ key: 'is_downloaded', value: JSON.stringify(mappedCardData?.[cardIndex]?.user_data?.[0]?.is_downloaded) });

    if (cardIndex == -1) {
      // ID Card not found and making new one
      setCardPushState({ cardUpdate: false, verified: false });
    } else {
      const userDataObj = mappedCardData?.[cardIndex]?.user_data?.[0];
      const isDownloaded = userDataObj?.is_downloaded === 1;

      // Check if card is downloaded - navigate directly to preview
      if (isDownloaded) {
        const idCard = mappedCardData?.[cardIndex]?.id_card;
        const userDetails = userDataObj?.user_details || {};
        
        // Separate text and image fields
        const textFields = {};
        const frontImages = {};
        const backImages = {};
        
        // Extract text fields from front
        if (idCard?.view_data?.id_front?.text_objects) {
          idCard.view_data.id_front.text_objects.forEach(text => {
            if (userDetails[text.tag] !== undefined) {
              textFields[text.tag] = userDetails[text.tag];
            }
          });
        }
        
        // Extract image fields from front
        if (idCard?.view_data?.id_front?.image_objects) {
          idCard.view_data.id_front.image_objects.forEach(img => {
            if (userDetails[img.tag] !== undefined && userDetails[img.tag]) {
              frontImages[img.tag] = userDetails[img.tag];
            }
          });
        }
        
        // Extract text and image fields from back (if exists)
        if (idCard?.type == 2 && idCard?.view_data?.id_back) {
          if (idCard.view_data.id_back.text_objects) {
            idCard.view_data.id_back.text_objects.forEach(text => {
              if (userDetails[text.tag] !== undefined) {
                textFields[text.tag] = userDetails[text.tag];
              }
            });
          }
          
          if (idCard.view_data.id_back.image_objects) {
            idCard.view_data.id_back.image_objects.forEach(img => {
              if (userDetails[img.tag] !== undefined && userDetails[img.tag]) {
                backImages[img.tag] = userDetails[img.tag];
              }
            });
          }
        }
        
        // Ensure cData has id field
        const cDataWithId = { 
          ...idCard, 
          id: idCard?.id || idCard?.icard_id 
        };
        
        // Navigate to preview with all existing data
        enqueueSnackbar('Your id card is downloaded for print', { variant: 'info' });
        history.push('/preview', {
          cData: cDataWithId,
          user_data: textFields,
          img_data: {
            updateDataImage: frontImages,
            updateDataImageBack: backImages
          },
          mapped_id: userDataObj?.mapped_id,
          cardUpdate: true,
          downloaded: true,
          after_update_push: '/home'
        });
        return;
      }
      
      // ID Card found and updating (not downloaded)
      const filteredData = onUpdateFilterData(
        mappedCardData?.[cardIndex]?.id_card, 
        userDataObj
      );
      
      if (filteredData) {
        setCardPushState({
          cData: filteredData,
          cardUpdate: true,
          mapped_id: userDataObj?.mapped_id,
          after_update_push: '/home',
          // after_update_push: '/idcard-verification-status',
          verified: userDataObj?.is_verified,
          downloaded: userDataObj?.is_downloaded,
        });
      }
    }
  }

  // const fetchIDcardByClassID = async () => {
  //   const { value } = await Preferences.get({ key: 'gjaii_IDCARD_user' });
  //   if (value == 'undefined' || !JSON.parse(value)?.schoolid) return enqueueSnackbar('Please Try Again !!!', { variant: 'error' });

  //   await axios.post(`${process.env.REACT_APP_BASE_URL}/user/getidcardbyclassid`, { class_id: JSON.parse(value)?.schoolid }) // Send school ID saved in Local Storage
  //     .then(res => {
  //       if (res.data.success) {
  //         // setCardData(res.data.data)
  //         setCardData(res?.data?.data?.[0])
  //       } else {
  //         enqueueSnackbar(res.data.message, { variant: 'error' });
  //       }
  //       setLoading(false);
  //     })
  //     .catch(err => {
  //       console.log(err);
  //       setLoading(false);
  //       enqueueSnackbar('Error, Please Try Again !!!', { variant: 'error' });
  //     })
  // }
  console.log();
  // const fetchMappedData = async () => {
  //   const { value } = await Preferences.get({ key: 'gjaii_IDCARD_user' });

  //   if (value == 'undefined' || !JSON.parse(value)?.id) return enqueueSnackbar('Please Try Again !!!', { variant: 'error' });

  //   await axios.post(`${process.env.REACT_APP_BASE_URL}/user/getmapped_data_byuserid`, { user_id: JSON.parse(value)?.id })
  //     .then(async res => {
  //       if (res.data.success) {
  //         await Preferences.set({ key: 'gjaai_user_mappedData', value: JSON.stringify(res.data.data) })
  //       } else {
  //         await Preferences.set({ key: 'gjaai_user_mappedData', value: undefined })
  //       }
  //     })
  //     .catch(err => {
  //       console.log(err);
  //       enqueueSnackbar('Error, Please Try Again !!!', { variant: 'error' });
  //     })
  // }

  return (
    <IonicPageWrapper headerTitle='Content' showLogout >
      <div id="content">
        <section className='content_cont' >
          <p style={{ textAlign: "center", marginTop: "20px" }}>Loading...</p>
        </section>
      </div>
    </IonicPageWrapper>
  )
}

export default Content
